module.exports = __webpack_public_path__ + "img/2.db02580e.png";